import * as Sentry from '@sentry/react'

import { env } from '@/lib/env'
import { router } from '@/routes'

const ENV = env.ENV
const SENTRY_DSN = env.SENTRY_DSN
const INTERNAL_API_HOST = env.INTERNAL_API_HOST

Sentry.init({
  dsn: ENV !== 'local' ? SENTRY_DSN : undefined,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.tanstackRouterBrowserTracingIntegration(router),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [`${INTERNAL_API_HOST}/`],
      networkRequestHeaders: ['Content-Type'],
      networkResponseHeaders: ['Content-Type'],
    }),
  ],
  environment: ENV,
  // tracesSampleRate sets a header which throws a CORS error when pointed at localhost api
  ...(ENV !== 'local' ? { tracesSampleRate: 1.0 } : {}),

  denyUrls: [/hubspot\.com/i, /google-analytics\.com/i, /hotjar\.com/i, /mixpanel\.com/i],

  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})
